const UiUtil = {

  scrollToElement(element) {
    const scrollTo = $(element).offset().top;
    $('html, body').animate({ scrollTop: scrollTo }, 500);
  },

};

export default UiUtil;



// WEBPACK FOOTER //
// ./javascripts/components/utils/ui.js